//const dev_url = "https://api.xy.mifengbangzu.com";
const dev_url = "http://192.168.244.129:8811";
const prod_url = "https://api.aj.mifengbangzu.com";

export const baseUrl =
    process.env.NODE_ENV == "production" ? prod_url : dev_url; // 测试

export const Url = process.env.NODE_ENV == "production" ? prod_url : dev_url;

export const imgBaseUrl = "http://qn.fayuanhui.cn/default.png";
export const version = "1.2.3";

export default {
    baseUrl,
    imgBaseUrl,
    version,
    Url,
};


// WEBPACK FOOTER //
// ./src/config/CONSTANTS.js